module.exports = __webpack_public_path__ + "img/option_d.f4f3df50.png";